export default "__VITE_ASSET__36e3a2d8__"